// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuctionActivityAlpTitle_wrapper__2Oe16","mobileText":"AuctionActivityAlpTitle_mobileText__e0dgu"};